import { render, staticRenderFns } from "./PayoutTags.vue?vue&type=template&id=03c8809b&"
import script from "./PayoutTags.vue?vue&type=script&lang=js&"
export * from "./PayoutTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports